<template lang="pug">
  .distributor-section
    DistributorMap(
      :pins="props.distributors"
      :centerLat="props.centerLat"
      :centerLng="props.centerLng"
      :zoom="props.zoom"
      :mobileCenterLat="props.mobileCenterLat"
      :mobileCenterLng="props.mobileCenterLng"
      :mobileZoom="props.mobileZoom"
      :height="props.height"
      :mobileHeight="props.mobileHeight"
      :mapStyle="props.mapStyle"
    )
</template>
<script setup lang="ts">
import DistributorMap from './DistributorMap.vue'
import type { DistributorPin } from './distributorMapTypes'

const props = withDefaults(defineProps<{
  distributors?: DistributorPin[]
  centerLat?: number
  centerLng?: number
  zoom?: number
  mobileCenterLat?: number
  mobileCenterLng?: number
  mobileZoom?: number
  height?: string
  mobileHeight?: string
  mapStyle?: string
}>(), {
  distributors : () => [],
  centerLat    : 20,
  centerLng    : 0,
  zoom         : 1.5,
  height       : '600px',
  mapStyle     : 'mapbox://styles/mapbox/dark-v11',
})
</script>